const styles = (theme) => ({
	paper: {
		borderRadius: 3,
		width: "100%",
		maxWidth: 420,
	},
	header: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		px: 3,
		py: 2,
	},
	headerTitleBox: {
		display: "flex",
		alignItems: "center",
		gap: 1.2,
	},
	headerIconBox: (isOnline) => ({
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: 36,
		height: 36,
		borderRadius: "50%",
		bgcolor: isOnline
			? theme.palette.chip.background["success"]
			: theme.palette.chip.background["critical"],
		color: isOnline
			? theme.palette.chip.colorText["success"]
			: theme.palette.chip.colorText["critical"],
	}),
	content: {
		px: 3,
		pb: 3,
		pt: 1,
		display: "flex",
		flexDirection: "column",
		gap: 1.5,
	},
	fieldRow: {
		display: "flex",
		alignItems: "center",
		gap: 1.5,
		p: 1.5,
		borderRadius: 2,
		bgcolor: theme.palette.action.hover,
		transition: "background-color 0.15s ease",
		"&:hover": {
			bgcolor: theme.palette.divider,
		},
	},
	fieldIcon: {
		fontSize: 20,
		color: theme.palette.primary.main,
		flexShrink: 0,
	},
	fieldTextBox: {
		display: "flex",
		flexDirection: "column",
		minWidth: 0,
		flex: 1,
	},
	fieldLabel: {
		fontSize: 12,
		fontWeight: 600,
		color: theme.palette.text.secondary,
		textTransform: "uppercase",
		letterSpacing: 0.4,
	},
	fieldValue: {
		fontSize: 14,
		fontWeight: 500,
		fontFamily: "monospace",
		cursor: "pointer",
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
	},
	emptyState: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		gap: 1,
		py: 4,
		color: theme.palette.text.disabled,
		textAlign: "center",
	},
});

export default styles;
